export const sessionAuthenticationSteps = {
  login: 'login',
  email: 'confirmation-email',
  code: 'confirmation-code',
  accaunt: 'accaunt-data',
  resetPassword: 'reset-password',
  resetPasswordSuccess: 'resetPasswordSuccess',
};
